<template>
  <div class="text-center">
    <v-dialog
      width="500"
      :value="updateObjectStatus['isOpenModal']"
      persistent
    >
      <v-card class="tw-pt-6">
        <v-card-title v-if="updateObjectStatus['status'] === 'success'" class="tw-text-xl tw-font-bold">ปรับแพคเกจเรียบร้อย</v-card-title>
        <v-card-text class="tw-mt-2">
          <p v-if="updateObjectStatus['status'] === 'success'" class="tw-text-lg tw-font-bold">ระบบจะดำเนินการปรับแพ็คเกจใหม่ในรอบบิลถัดไป</p>
          <p v-else class="tw-text-lg tw-font-bold">ตรวจพบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="onCloseModalUpdateAlert()">
            <v-icon class="tw-text-2xl tw-pr-1">mdi-close-circle-outline</v-icon>
            <span class="tw-text-lg">ปิด</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  name: 'AlertChangePackage',
  props: ['updateObjectStatus', 'onCloseModalUpdateAlert'],
}
</script>
